<div class="hero-numbers-container mb-2" *ngIf="rollupItems?.length">
  <app-roll-up-item *ngFor="let item of rollupItems" [item]="item"></app-roll-up-item>
</div>



